// Vista de las solicitudes 


// Imports 
import React from 'react';
import {Table, Col, Row, Input, Breadcrumb, Card, Spin, Button} from "antd";
import {Link} from 'react-router-dom';
import axios from "axios/index";

const {Search} = Input;
const {Column} = Table;

// Componente My Request 
class MyRequests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: "",
            visitaSinCargar: true,
            searchValue: "",
            //Total number
            total: 0,
            //Define query parameters
            query: {
                pageNumber: 1,
                pageSize: 10
            }
        }
    };
    
    //Función que se corre al cargar el componente 
    getList = () => {
        this.setState({visitaSinCargar: true})
        if(window.Roles !== null){
            //Tomamos todas las solicitudes de visita que nos entrega la api
            axios.post(window.ENV.API_URL + '/mis_solicitudes_listado/',{
                    page_number: this.state.query.pageNumber,
                    page_size: this.state.query.pageSize,
                    key_find: this.state.searchValue
                }, {
                    headers: {
                        Authorization: window.Token
                    }
            })
            .then((response_visit) => {
                if (response_visit.data.data == null) {
                    response_visit.data.data = []
                }
                const visitasF = response_visit.data.data.map(info => {
                    return {...info, key: info.id}
                });
                this.setState({data: visitasF,visitaSinCargar: false, total: response_visit.data.pagination.count})
                return visitasF
            });
        }
    };

    
    //Cargamos el componente 
    componentDidMount() {
        this.getList();
    };

    handleChangeSearch = (e) => {
        this.setState({searchValue: e.target.value, query: {pageNumber:1,pageSize:this.state.query.pageSize}});
    }

    render() {
        function parseRut(rutP){
            if(rutP != null){
                
                let flag_0 = 0;
                let rut_data = rutP;
                let rutPasaporte = '';
                
                if(rut_data[0] != 'P'){
                    for (let i = 0; i < rut_data.length; i++) {
                        if(rut_data[i] != 0){
                            flag_0 = 1;
                        }
    
                        if(flag_0 == 1){
                            if(i < rut_data.length-1){
                                rutPasaporte = rutPasaporte + rut_data[i]
                            }else{
                                rutPasaporte = rutPasaporte + '-' + rut_data[i]
                            }
                        }
                    }
                }else{
                    rutPasaporte = rut_data;
                }
    
                return rutPasaporte;
            }
        }

        const columns = [
            {
                title: <label className='prorroga-title'>Rut/Pasaporte</label>,
                dataIndex: "",
                render: text => <Link className='prorroga-body-data' to={`/viewform/${text.ID_VISITA}`}>{parseRut(text?.RUT_PASAPORTE)}</Link>
            },
            {
                title: <label className='prorroga-title'>Nombre</label>,
                dataIndex: "",
                render: text => <Link className='prorroga-body-data' to={`/viewform/${text.ID_VISITA}`}> {text?.NOMBRES} {text?.PATERNO} {text?.MATERNO} </Link>
            },
            {
                title: <label className='prorroga-title'>Fecha de Ingreso</label>,
                dataIndex: "",
                render: text => <Link className='prorroga-body-data' to={`/viewform/${text.ID_VISITA}`}>{text.FECHA_CREACION.substring(8,10) + '-' + text.FECHA_CREACION.substring(5,7) + '-' + text.FECHA_CREACION.substring(0,4)}</Link>
            },
            {
                title: <label className='prorroga-title'>Estado</label>,
                dataIndex: "",
                render: text => <Link className='prorroga-body-data' to={`/viewform/${text.ID_VISITA}`}>{text.ESTADO}</Link>
            },
            {
                title: <label className='prorroga-title'>Repartición</label>,
                dataIndex: "",
                render: text => <Link className='prorroga-body-data' to={`/viewform/${text.ID_VISITA}`}>{text.ORGANISMO.REPARTICION?.nombre}</Link>
            },
            {
                title: <label className='prorroga-title'>Organismo</label>,
                dataIndex: "",
                render: text => <Link className='prorroga-body-data' to={`/viewform/${text.ID_VISITA}`}>{text.ORGANISMO.ORGANISMO?.nombre}</Link>
            },
            {
                title: <label className='prorroga-title'>Departamento</label>,
                dataIndex: "",
                render: text => <Link className='prorroga-body-data' to={`/viewform/${text.ID_VISITA}`}>{text.ORGANISMO.DEPARTAMENTO?.nombre}</Link>
            },
            {
                title: <label className='prorroga-title'>Tipo Visita</label>,
                dataIndex: "",
                render: text => <Link className='prorroga-body-data' to={`/viewform/${text.ID_VISITA}`}>{text.TIPO_VISITA}</Link>
            }
        ];

        return (
            <div>
                <Spin tip="Cargando Datos…" spinning={this.state.visitaSinCargar}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <a href="/main">Menú principal</a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Mis solicitudes</Breadcrumb.Item>
                    </Breadcrumb>

                    <Card>
                        <div style={{fontSize:"25px", color:"#1978B8"}}><b>Mis Solicitudes</b></div>
                        <Row>
                            <Input className="search-input" style={{margin: 10}} placeholder="Buscar por palabras claves para Rut, Nombre, Estado, Organismos o Tipo de Visita" onBlur={this.handleChangeSearch}/>
                            <Button className="global-principal-button" style={{margin: 10}} onClick={() => this.getList()}>BUSCAR</Button>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Table columns={columns} dataSource={this.state.data}
                                    // Add paging component
                                    pagination={{
                                        // Set the total number
                                        total: this.state.total,
                                        // Option to set page number
                                        pageSizeOptions: ["5","10", "20", "50"],
                                        // display the total number
                                        showTotal: total => `Total ${total} visitas`,
                                        // Is it possible to change pageSize
                                        showSizeChanger: true,
                                        current: this.state.query.pageNumber,
                                        // When changing the page number
                                        onChange: ((page, pageSize) => {
                                            this.setState({
                                                query: {
                                                    pageNumber: page,
                                                    pageSize: pageSize
                                                }
                                            }, () => {
                                                this.getList()
                                            })
                                        }),
                                        // callback for pageSize change
                                        onShowSizeChange: (page, pageSize) => {
                                            // this.state.visitaSinCargar = true;
                                            this.setState({
                                                query: {
                                                    pageNumber: page,
                                                    pageSize: pageSize
                                                }
                                            }, () => {
                                                this.getList()
                                            })
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                    </Card>
                </Spin>
            </div>
        );
    }
}

export default MyRequests;